/* ==========================================================================
   PDP Matratzenhoehe: Pflichtfeld, Fehleranzeige, automatische Stufenwahl
   Leinenweberei Hoffmann, 09.08.2026

   Ausgangslage: In sections/pdp-main.liquid wurde das required-Attribut nur
   gesetzt, wenn das Metafeld pdp.matratzenhoehe befuellt war. Bei den
   Spannbettlaken erscheint das Feld aber ueber den Produkt-Tag, also stand nie
   ein required im HTML. Damit lief weder die Browser-Pruefung noch der
   vorhandene Guard in assets/pdp.js (der genau dieses Attribut abfragt).
   Auswertung 10.06. bis 09.08.2026: 15 von 33 Spannbettlaken-Positionen ohne Mass.

   Dieses Skript ergaenzt die bestehende Buy-Box zur Laufzeit:
   1. setzt required und vereinheitlicht den Property-Namen auf
      Matratzenhoehe (cm). Die Einheit steckt damit im Namen; JTL importiert
      Line Item Properties in das Hinweisfeld der Bestellposition.
   2. blockiert den Warenkorb-Klick bei leerem oder unbrauchbarem Feld, scrollt
      hin, setzt den Fokus, laesst das Feld kurz wackeln und zeigt eine Meldung
      darunter. Der Button bleibt klickbar und unveraendert beschriftet.
      Der Listener haengt in der Capture-Phase auf document, laeuft also vor dem
      CTA-Listener in pdp-addons.js (Veredelung, Bundle, Wende-Set, postet direkt
      an /cart/add.js) und faengt auch den synthetischen Klick der mobilen
      Sticky-Bar ab (assets/pdp-mobile.js ruft mainBtn.click()).
      Muster uebernommen aus assets/pdp-wende.js.
   3. faerbt den Rahmen erst nach dem ersten Absendeversuch, vorher neutral,
      und zeigt bei gueltigem Wert einen Haken.
   4. Das eingetragene Mass ist fuehrend: passt die gewaehlte Stufe (bis 20/30/40)
      nicht dazu, wird die Stufe automatisch auf die kleinste passende gesetzt
      und der Kunde darauf hingewiesen, weil sich der Preis dabei aendert.
      Umgeschaltet wird beim Verlassen des Feldes, kurz nach dem Tippen und
      spaetestens beim Klick auf den Warenkorb. Beim Klick wird dieser eine
      Klick gestoppt, damit niemand einen anderen Preis bezahlt als angezeigt.
      Waehrend des Tippens wird nicht umgeschaltet, sonst springt der Preis
      bei jeder Ziffer.

   Bewusst KEINE feste Unter- oder Obergrenze im Text: die Obergrenze ergibt
   sich aus der groessten angebotenen Stufe, alles darunter ist erlaubt, weil
   es duenne Matratzen und Auflagen gibt.
   ========================================================================== */
(function () {
  'use strict';

  var PROPERTY_NAME = 'Matratzenhöhe (cm)';
  var CUSTOM_SIZE_LINK = '/pages/massanfertigungen';
  var SWITCH_DELAY = 800;
  var DQ = String.fromCharCode(34);

  function injectStyles() {
    if (document.getElementById('pdp-height-styles')) return;
    var css = [
      /* assets/pdp.js setzt is-empty schon beim Seitenaufruf. Ein Rahmen, der
         immer leuchtet, wird nicht mehr wahrgenommen. Daher neutralisiert. */
      '.pdp-height-input.is-empty{border-color:var(--pdp-chip-border);}',
      '.pdp-height-input.is-error{border-color:var(--pdp-sale);background:#FDF6F4;}',
      '.pdp-height-input.is-valid{border-color:var(--pdp-success-border);background:var(--pdp-success-bg);}',
      '.pdp-height-valid-mark{display:none;flex:none;line-height:1;font-size:15px;color:var(--pdp-success-text);}',
      '.pdp-height-input.is-valid + .pdp-height-valid-mark{display:inline-block;}',
      '.pdp-height-msg{margin-top:8px;font-size:13px;line-height:1.45;padding:9px 11px;border:1px solid transparent;border-radius:4px;}',
      '.pdp-height-msg[hidden]{display:none;}',
      '.pdp-height-msg--error{background:#FDF6F4;border-color:#E2C3BC;color:var(--pdp-sale);}',
      '.pdp-height-msg--notice{background:var(--pdp-notice-bg);border-color:var(--pdp-notice-border);color:var(--pdp-notice-text);}',
      '.pdp-height-msg--success{background:var(--pdp-success-bg);border-color:var(--pdp-success-border);color:var(--pdp-success-text);}',
      '.pdp-height-msg a{color:inherit;}',
      '@keyframes pdpHeightShake{0%,100%{transform:translateX(0);}20%{transform:translateX(-5px);}40%{transform:translateX(5px);}60%{transform:translateX(-3px);}80%{transform:translateX(3px);}}',
      '.pdp-height-field.is-shaking{animation:pdpHeightShake .45s ease-in-out;}',
      '@media (prefers-reduced-motion: reduce){.pdp-height-field.is-shaking{animation:none;}}'
    ].join(' ');
    var el = document.createElement('style');
    el.id = 'pdp-height-styles';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function escapeHtml(str) {
    return String(str)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split(DQ).join('&quot;');
  }

  function firstNumber(str) {
    var m = String(str).match(/([0-9]+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function init(root) {
    var input = root.querySelector('[data-pdp-height]');
    if (!input || input.dataset.pdpHeightReady) return;
    input.dataset.pdpHeightReady = '1';

    injectStyles();

    var field = input.closest('.pdp-height-field') || input.parentNode;
    var row = input.parentNode;

    /* ---------- 1. Feld schaerfen ---------- */
    input.setAttribute('required', 'required');
    input.setAttribute('name', 'properties[' + PROPERTY_NAME + ']');
    input.setAttribute('type', 'number');
    input.setAttribute('min', '1');
    input.setAttribute('step', '1');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'off');
    input.removeAttribute('max');

    if (!row.querySelector('.pdp-height-valid-mark')) {
      var mark = document.createElement('span');
      mark.className = 'pdp-height-valid-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = '&#10003;';
      if (input.nextSibling) row.insertBefore(mark, input.nextSibling);
      else row.appendChild(mark);
    }

    var msg = field.querySelector('.pdp-height-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'pdp-height-msg';
      msg.setAttribute('role', 'status');
      msg.hidden = true;
      msg.id = 'pdp-height-msg-' + (input.id || 'x');
      field.appendChild(msg);
      input.setAttribute('aria-describedby', msg.id);
    }

    /* ---------- 2. Stufengruppe im DOM finden ---------- */
    var stepSelect = null;
    var stepName = null;
    var groups = root.querySelectorAll('.pdp-size-group');
    for (var g = 0; g < groups.length; g++) {
      var label = groups[g].querySelector('.pdp-option-label');
      if (!label) continue;
      if (label.textContent.toLowerCase().indexOf('matratzenh') === -1) continue;
      var sel = groups[g].querySelector('select[name^=option]');
      if (sel) { stepSelect = sel; stepName = sel.getAttribute('name'); break; }
      var radios = groups[g].querySelectorAll('input[type=radio][name^=option]');
      if (radios.length) { stepName = radios[0].getAttribute('name'); break; }
    }

    function stepOptions() {
      var list = [];
      if (stepSelect) {
        Array.prototype.forEach.call(stepSelect.options, function (o) {
          list.push({ value: o.value, apply: function () { stepSelect.value = o.value; } });
        });
      } else if (stepName) {
        Array.prototype.forEach.call(root.querySelectorAll('input[name=' + stepName + ']'), function (r) {
          list.push({ value: r.value, apply: function () { r.checked = true; } });
        });
      }
      return list;
    }
    function currentStep() {
      if (stepSelect) return stepSelect.value || null;
      if (!stepName) return null;
      var checked = root.querySelector('input[name=' + stepName + ']:checked');
      return checked ? checked.value : null;
    }
    function fireChange() {
      var target = stepSelect || root.querySelector('input[name=' + stepName + ']:checked');
      if (target) target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    /* kleinste Stufe, in die das Mass noch passt */
    function matchingStep(cm) {
      var best = null, bestLimit = Infinity;
      stepOptions().forEach(function (opt) {
        var lim = firstNumber(opt.value);
        if (lim !== null && cm <= lim && lim < bestLimit) { best = opt; bestLimit = lim; }
      });
      return best;
    }
    function largestLimit() {
      var max = null;
      stepOptions().forEach(function (opt) {
        var lim = firstNumber(opt.value);
        if (lim !== null && (max === null || lim > max)) max = lim;
      });
      return max;
    }

    /* Obergrenze fuer die Browser-Pruefung aus den angebotenen Stufen ableiten,
       damit sie automatisch stimmt, wenn eine Stufe dazukommt oder wegfaellt. */
    var hardMax = largestLimit();
    if (hardMax !== null) input.setAttribute('max', String(hardMax));

    /* ---------- 3. Meldungen ---------- */
    function showMsg(html, kind) {
      msg.innerHTML = html;
      msg.className = 'pdp-height-msg pdp-height-msg--' + kind;
      msg.hidden = false;
    }
    function hideMsg() {
      msg.hidden = true;
      msg.innerHTML = '';
      msg.className = 'pdp-height-msg';
    }

    var touched = false;
    var typeTimer = null;

    /* showErrors erst ab dem ersten Absendeversuch bzw. nachdem das Feld
       einmal mit Inhalt verlassen wurde. Vorher bleibt alles neutral.
       autoSwitch steuert, ob die Stufe jetzt angepasst werden darf. */
    function validate(showErrors, autoSwitch) {
      var raw = input.value.trim();
      input.classList.remove('is-error', 'is-valid', 'is-empty');
      input.removeAttribute('aria-invalid');

      function fail(text) {
        if (showErrors) {
          input.classList.add('is-error');
          input.setAttribute('aria-invalid', 'true');
          showMsg(text, 'error');
        } else {
          hideMsg();
        }
        return false;
      }

      if (raw === '') {
        return fail('Bitte tragen Sie hier noch die Höhe Ihrer Matratze ein, damit wir die Steghöhe passend nähen können.');
      }

      var cm = parseInt(raw, 10);
      if (isNaN(cm) || cm < 1) {
        return fail('Bitte tragen Sie die Höhe Ihrer Matratze in Zentimetern ein.');
      }

      var target = matchingStep(cm);
      if (!target) {
        /* Ueber der groessten Stufe: hier hilft nur eine Sonderanfertigung. */
        return fail('Für ' + cm + ' cm reicht keine der angebotenen Höhen. Wir fertigen das Laken gern nach Ihrem Maß: <a href=' + CUSTOM_SIZE_LINK + '>Wunschmaß anfragen</a>');
      }

      input.classList.add('is-valid');

      var step = currentStep();
      if (step && target.value !== step) {
        if (autoSwitch) {
          target.apply();
          fireChange();
          showMsg('Für ' + cm + ' cm passt die Höhe ' + escapeHtml(target.value) +
            '. Wir haben sie für Sie eingestellt, der Preis oben hat sich entsprechend geändert.', 'success');
        } else {
          hideMsg();
        }
        return true;
      }

      hideMsg();
      return true;
    }

    input.addEventListener('input', function () {
      validate(touched, false);
      clearTimeout(typeTimer);
      /* kurze Pause abwarten, sonst springt die Stufe schon nach der ersten Ziffer */
      typeTimer = setTimeout(function () { validate(touched, true); }, SWITCH_DELAY);
    });
    input.addEventListener('blur', function () {
      clearTimeout(typeTimer);
      if (input.value.trim() !== '') touched = true;
      validate(touched, true);
    });
    root.addEventListener('change', function (e) {
      if (!stepName || !e.target || e.target.name !== stepName) return;
      /* Waehlt der Kunde selbst eine Stufe, wird nicht sofort zurueckgesprungen.
         Korrigiert wird spaetestens beim Klick auf den Warenkorb. */
      validate(touched, false);
    });

    /* ---------- 4. Guard ---------- */
    function stop(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      field.classList.remove('is-shaking');
      void field.offsetWidth;
      field.classList.add('is-shaking');
      setTimeout(function () { field.classList.remove('is-shaking'); }, 600);
      try {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        input.scrollIntoView();
      }
      setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (err2) { input.focus(); }
      }, 350);
    }

    function blockIfInvalid(e) {
      touched = true;
      clearTimeout(typeTimer);
      var before = currentStep();
      var ok = validate(true, true);
      if (!ok) { stop(e); return true; }
      var after = currentStep();
      if (before !== after) {
        /* Die Stufe wurde in genau diesem Moment angepasst. Diesen einen Klick
           stoppen, damit niemand einen anderen Preis bezahlt als angezeigt. */
        showMsg('Wir haben die Höhe auf ' + escapeHtml(after) +
          ' angepasst. Bitte prüfen Sie kurz den Preis und legen Sie dann in den Warenkorb.', 'notice');
        stop(e);
        return true;
      }
      return false;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-product-add-to-cart-button]');
      if (!btn || !root.contains(btn)) return;
      blockIfInvalid(e);
    }, true);

    var formId = input.getAttribute('form');
    var form = formId ? document.getElementById(formId) : input.closest('form');
    if (form) form.addEventListener('submit', function (e) { blockIfInvalid(e); }, true);

    validate(false, false);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-main]').forEach(function (root) { init(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();